/*
 * build.REACT_APP_VERSION is defined at build time (vite.config.ts)
 * you could override it with env. variable REACT_APP_VERSION if you'd like to
 */
export const appVersion = () =>
  import.meta.env.REACT_APP_VERSION! || build.REACT_APP_VERSION;
export const sentryDsn = () => import.meta.env.REACT_APP_SENTRY_DSN!;
export const featureShortenedTablesForEnormousVariables = () =>
  toBoolean(
    import.meta.env.REACT_APP_FEATURE_SHORTENED_TABLES_FOR_ENORMOUS_VARIABLES,
  );
export const drawIoServerUrl = () =>
  import.meta.env.REACT_APP_DRAW_IO_SERVER_URL!;

export const FeatureFlags = {
  templateMergingPageEnabled: () =>
    toBoolean(import.meta.env.REACT_APP_TEMPLATE_MERGING_PAGE_ENABLED),
  umamiUrl: () => import.meta.env.REACT_APP_UMAMI_URL,
  umamiSiteId: () => import.meta.env.REACT_APP_UMAMI_SITE_ID,
  documentExportingWithVariableUpdateEnabled: () =>
    toBoolean(
      import.meta.env.REACT_APP_DOCUMENT_EXPORTING_WITH_VARIABLE_UPDATE_ENABLED,
    ),
  projectPermissionsEnabled: () =>
    toBoolean(import.meta.env.REACT_APP_PROJECT_PERMISSIONS_ENABLED),
  aiChatEnabled: () => toBoolean(import.meta.env.REACT_APP_AI_CHAT_ENABLED),
};

/*
 * This function converts 'false', '0', null, undefined to boolean `false`
 * Everything else is converted to boolean `true`.
 * (all default conversions like `!!value` or `Boolean(value)` do not convert 'false' to boolean false
 */
function toBoolean(value: string): boolean {
  if (!value) return false;
  const lowercaseValue = value.toLowerCase();
  if (lowercaseValue === 'false' || lowercaseValue === '0') return false;
  return true;
}
